import * as MutationTypes from './mutationTypes';

const userRoleListSuccess = (state, payload) => {
  state.userRoleList = payload;
};

const createUserRoleSuccess = (state, payload) => {
  state.createUserRoleSuccess = payload;
};

const updateUserRoleSuccess = (state, payload) => {
  state.updateUserRoleSuccess = payload;
};

const deleteUserRoleSuccess = (state, payload) => {
  state.deleteUserRoleSuccess = payload;
};

const regeneratePasswordUserRoleSuccess = (state, payload) => {
  state.regeneratePasswordUserRoleSuccess = payload;
};

export const mutations = {
  [MutationTypes.USER_ROLE_LIST_SUCCESS]: userRoleListSuccess,
  [MutationTypes.CREATE_USER_ROLE_SUCCESS_SUCCESS]: createUserRoleSuccess,
  [MutationTypes.UPDATE_USER_ROLE_SUCCESS]: updateUserRoleSuccess,
  [MutationTypes.DELETE_USER_ROLE_SUCCESS]: deleteUserRoleSuccess,
  [MutationTypes.REGENERATE_PASSWORD_USER_ROLE_SUCCESS]: regeneratePasswordUserRoleSuccess,
};
